import React from 'react';

const LinkioRobo = (props) => {
  return (
    <img {...props} src={require("../img/linkio_robo.svg")} />
  );
};

export default LinkioRobo;
